/**
 * Announcements data hooks — PEL-823.
 *
 * Read-only. List comes from `/announcements` on the backend and is shown
 * in the Home "What's New" section and (future) a dedicated inbox tab.
 */

import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type { Announcement } from '@pelipost/consumer-api-client';
import { api } from '../lib/api/client';

export const announcementsKeys = {
  all: ['announcements'] as const,
};

/** List active announcements for the signed-in user. */
export function useAnnouncementsList(
  options?: Omit<UseQueryOptions<Announcement[]>, 'queryKey' | 'queryFn'>,
) {
  return useQuery<Announcement[]>({
    queryKey: announcementsKeys.all,
    queryFn: () => api.announcements.getAnnouncements(),
    // Announcements change rarely — a 5-minute stale window avoids
    // hammering the endpoint on every home revisit.
    staleTime: 5 * 60 * 1000,
    ...options,
  });
}
